export default "__VITE_ASSET__CaIno2WL__"